module.exports = __webpack_public_path__ + "img/icon-work.03e3b4ef.png";